export const GET_LISTALLSHOWS = 'GET_LISTALLSHOWS';
export const GET_LISTALLSHOW = 'GET_LISTALLSHOW';
export const ADD_LISTALLSHOW = 'ADD_LISTALLSHOW';
export const UPDATE_LISTALLSHOW = 'UPDATE_LISTALLSHOW';
export const DELETE_LISTALLSHOW = 'DELETE_LISTALLSHOW';
export const TOGGLE_DIALOG = 'TOGGLE_DIALOG';
export const SELECT_LISTALLSHOWS = 'SELECT_LISTALLSHOWS';
export const SELECT_ALL_LISTALLSHOWS = 'SELECT_ALL_LISTALLSHOWS';